import styled from "styled-components";
import { MOBILE_WIDTH } from "../../constants";

export const LiveSessionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media ${MOBILE_WIDTH} {
    flex-direction: column;
  }
`;

export const YoutubeContainer = styled.div`
  width: 35%;
  min-height: 500px;
  @media ${MOBILE_WIDTH} {
    width: 100%;
    min-height: 349px;
  }
`;

export const YoutubeVideoContainer = styled.div`
  height: calc(100% - 113px);
  width: 100%;
  @media ${MOBILE_WIDTH} {
    height: calc(${(props) => props.$height} - 97px);
  }
`;

export const SessionThumbnail = styled.img`
  width: 65%;
  object-fit: cover;
  object-position: 90% 20%;
  @media ${MOBILE_WIDTH} {
    display: none;
  }
`;
